// 檢查上傳檔案是否為jpg, jpeg, png類型
const checkFileMagicNumbers = (file: File): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      if (reader.result instanceof ArrayBuffer) {
        const arr = new Uint8Array(reader.result as ArrayBuffer).subarray(0, 4)
        let header = ''
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16)
        }
        // JPEG: ffd8ffe0, ffd8ffe1, ffd8ffe2, ffd8ffe3, ffd8ffe8
        // PNG: 89504e47
        if (header.startsWith('ffd8ffe') || header === '89504e47') {
          resolve(true)
        } else {
          resolve(false)
        }
      } else {
        reject(new Error('讀取檔案失敗'))
      }
    }

    reader.onerror = () => {
      reject(new Error('讀取檔案時發生錯誤'))
    }

    reader.readAsArrayBuffer(file.slice(0, 4))
  })
}

export { checkFileMagicNumbers }
